import { ReactComponent as FlagNetherlands } from "../styles/svg/flags/netherlands.svg";
import { ReactComponent as FlagBritain } from "../styles/svg/flags/britain.svg";
import { ReactComponent as FlagGermany } from "../styles/svg/flags/germany.svg";
import { ReactComponent as FlagFrance } from "../styles/svg/flags/france.svg";
import { ReactComponent as FlagSpain } from "../styles/svg/flags/spain.svg";
import { ReactComponent as FlagPortugal } from "../styles/svg/flags/portugal.svg";
import { ReactComponent as FlagDenmark } from "../styles/svg/flags/denmark.svg";
import { ReactComponent as FlagSweden } from "../styles/svg/flags/sweden.svg";
import { ReactComponent as FlagNorway } from "../styles/svg/flags/norway.svg";
import { ReactComponent as FlagFinland } from "../styles/svg/flags/finland.svg";
import { enUS, nl, de, fr, es, pt, da, sv, nb, fi } from 'date-fns/locale';

export const localeSettings = {
    'nl': {
        language: "Nederlands",
        short:'nl',
        flag: <FlagNetherlands/>,
        dateLocale: nl,
    },
    'en': {
        language: "English",
        short:'en',
        flag: <FlagBritain/>,
        dateLocale:enUS
    },
    'de': {
        language: "Deutsch",
        short:'de',
        flag: <FlagGermany/>,
        dateLocale: de,
    },
    'fr': {
        language: "Français",
        short:'fr',
        flag: <FlagFrance/>,
        dateLocale: fr,
    },
    'es': {
        language: "Español",
        short:'es',
        flag: <FlagSpain/>,
        dateLocale: es,
    },
    'pt': {
        language: "Português",
        short:'pt',
        flag: <FlagPortugal/>,
        dateLocale: pt,
    },
    'da': {
        language: "Dansk",
        short:'da',
        flag: <FlagDenmark/>,
        dateLocale: da,
    },
    'sv': {
        language: "Svenska",
        short:'sv',
        flag: <FlagSweden/>,
        dateLocale: sv,
    },
    'nb': {
        language: "Norsk",
        short:'nb',
        flag: <FlagNorway/>,
        dateLocale: nb,
    },
    'fi': {
        language: "Suomi",
        short:'fi',
        flag: <FlagFinland/>,
        dateLocale: fi,
    },
}

// The locale that follows the given one in the localeSettings order, wrapping around.
// An unknown locale yields the first available one.
export const nextLocale = (current) => {
    const keys = Object.keys(localeSettings);
    return keys[(keys.indexOf(current) + 1) % keys.length];
}